import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormButton, FDN } from '@intersystems/isc-form';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-deployment-delete-dialog',
  templateUrl: './deployment-delete-dialog.component.html',
})
export class DeploymentDeleteDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DeploymentDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  FDN: FDN = {
    name: 'Delete Deployment',
    description: `All data and settings of this deployment will be permanently deleted.
                  You can't undo this action. Are you sure you want to delete the following deployment?`,
    validateOn: 'change',
    sectionLayout: { showSectionHeaders: false },
    sections: [
      {
        fields: [
          {
            id: 'deploymentName',
            key: 'deploymentName',
            type: 'input',
            viewOnly: true,
            templateOptions: {
              label: 'Deployment name',
            },
            data: {},
          },
          {
            id: 'confirmation',
            key: 'confirm',
            type: 'input',
            templateOptions: {
              label: 'Type "' + this.data.deploymentName + '" in the box below to delete deployment (case-sensitive)',
            },
          },
        ],
      },
    ],
  };

  buttons: FormButton[] = [
    {
      text: 'Delete',
      buttonClass: 'primary',
      id: 'delete',
      type: 'submit',
      disabled: (_formModel: any, _formOptions: any, form: any) =>
        form.valueChanges.pipe(map((formModel: any) => formModel.confirm != this.data.deploymentName)),
      callback: () => this.dialogRef.close(true),
    },
    {
      text: 'Cancel',
      buttonClass: 'secondary',
      id: 'cancel',
      type: 'submit',
      callback: () => this.dialogRef.close(false),
    },
  ];

  ngOnInit(): void {
    // remove extra spaces
    this.data.deploymentName = this.data.deploymentName.replace(/\s+/g, ' ').trim();
  }
}
